module.exports = __webpack_public_path__ + "img/FlySafair.6560fd8d.png";